import { createSlice } from "@reduxjs/toolkit";
import {
  getPendingBroadcastMessages,
  actionBroadcastMessage,
} from "@/services/broadcast.service";

const initialState = {
  messages: [],
  currentIndex: 0,
  isOpen: false,
  submitting: false,
  hasFetched: false,
};

export const broadcast = createSlice({
  name: "broadcast",
  initialState,
  reducers: {
    resetBroadcast: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPendingBroadcastMessages.pending, (state) => {
        state.hasFetched = true;
      })
      .addCase(getPendingBroadcastMessages.fulfilled, (state, action) => {
        const messages = action.payload?.data || [];
        const hasCreatedAt = messages.every((item) => item?.created_at);
        state.messages = hasCreatedAt
          ? [...messages].sort(
              (a, b) => new Date(a.created_at) - new Date(b.created_at)
            )
          : messages;
        state.currentIndex = 0;
        state.isOpen = state.messages.length > 0;
      })
      .addCase(getPendingBroadcastMessages.rejected, () => {
        // NO-OP: fetching announcements must never break the UI.
      })
      .addCase(actionBroadcastMessage.pending, (state) => {
        state.submitting = true;
      })
      .addCase(actionBroadcastMessage.fulfilled, (state) => {
        state.submitting = false;
        const nextIndex = state.currentIndex + 1;
        if (nextIndex >= state.messages.length) {
          state.isOpen = false;
          state.messages = [];
          state.currentIndex = 0;
        } else {
          state.currentIndex = nextIndex;
        }
      })
      .addCase(actionBroadcastMessage.rejected, (state) => {
        state.submitting = false;
        const nextIndex = state.currentIndex + 1;
        if (nextIndex >= state.messages.length) {
          state.isOpen = false;
          state.messages = [];
          state.currentIndex = 0;
        } else {
          state.currentIndex = nextIndex;
        }
      });
  },
});

export const { resetBroadcast } = broadcast.actions;
export default broadcast.reducer;
